module.exports = __webpack_public_path__ + "static/media/FemaleSprint.12fe5a0b.svg";